import { Constructor } from './constructor.type';
import { DynamicProperty } from '../decorators/dynamic-property.decorator';

export interface IDynamicMultiSelectMixin {
  isMultiSelect: boolean | undefined;
  showSelections: boolean | undefined;
}

export type DynamicMultiSelectCtor = Constructor<IDynamicMultiSelectMixin>;

export function mixinDynamicMultiSelect<T extends Constructor<{}>>(base: T): DynamicMultiSelectCtor & T {
  class DynamicMultiSelectMixin extends base implements IDynamicMultiSelectMixin {
    @DynamicProperty() isMultiSelect: boolean | undefined;
    @DynamicProperty() showSelections: boolean | undefined;

    constructor(...args: any[]) {
      super(...args);
    }
  }

  return DynamicMultiSelectMixin;
}
